/**
 * The legend for USA:usa_deer_movement, the deer movement model drawn as half-hour frames.
 * Each pixel is how much more or less deer move than usual for that time of day: the
 * model's score minus the national median at the same local solar hour, in score points,
 * on a fixed -20..+20 scale. The tiles come colored, so this must match gis-pipeline's
 * registry/deer_activity_tiles.py: a diverging ramp, night (outside legal light) in grey,
 * and contour lines every 5 points. HuntWind owns green / yellow / red, so none here.
 */

export const DEER_MOVEMENT_STOPS = [
  { color: '#2F5F9E', at: 0 },
  { color: '#7FA3CF', at: 0.25 },
  { color: '#E9E5DF', at: 0.5 },
  { color: '#F4AE62', at: 0.75 },
  { color: '#D9600C', at: 1 }
]

export const DEER_MOVEMENT_RAMP = `linear-gradient(to right, ${DEER_MOVEMENT_STOPS.map(s => `${s.color} ${s.at * 100}%`).join(', ')})`

export const DEER_MOVEMENT_NIGHT = '#4E4E4E'

// Score points against the hour's usual, at their place on the ramp.
export const DEER_MOVEMENT_TICKS = [
  { label: '−20', at: 0 },
  { label: '−10', at: 0.25 },
  { label: '0', at: 0.5 },
  { label: '+10', at: 0.75 },
  { label: '+20', at: 1 }
]

export const DEER_MOVEMENT_CAPTION = ['Less than usual', 'More than usual']

export const DEER_MOVEMENT_CAVEAT = 'Deer movement against what is usual for this time of day, in score points; ' +
  'lines every 5 points. Relative movement from GPS collars, not a count of deer. ' +
  'Prototype: no hunting-pressure shift yet, and nothing west of Kansas is in the training data.'
